import { useAxiosInterceptor } from '../../../api/wrappers';
import HeroSection from '../../../components/conduct-risk/HeroSection';
import ContainerConductRiskListaReportPage from '../../../components/conduct-risk/lista-report/ContainerConductRiskListaReportPage';
import { routesMap } from '../../../routes/routesMap';

const ConductRiskListaReportPage = () => {
  useAxiosInterceptor();

  return (
    <div className="ConductRiskListaReportPage">
      <HeroSection
        title="Lista Report Conduct Risk"
        description="In questa sezione puoi consultare e creare nuovi report di Conduct Risk."
        breadcrumbLinks={[
          { url: routesMap.HOME_PAGE, title: 'Home' },
          { url: routesMap.CONDUCT_RISK_HOME, title: 'Conduct Risk' },
          { url: '#', title: 'Report' },
        ]}
      />
      <ContainerConductRiskListaReportPage />
    </div>
  );
};

export default ConductRiskListaReportPage;
